<!------------ START TEMPLATE ------------>
<template>
  <div>
    <Modal
      class="holamundo"
      :title="titleSideBar"
      :active.sync="modalForm"
      @close="closeModais"
    >
      <formAddRegional
        :dados="dados"
        @close="closeModais"
        @concluido="concluido"
        :modal="modalForm"
      >
      </formAddRegional>
    </Modal>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col flex flex-col mb-6 w-full">
          <span>Token de api</span>
          <vs-button
            v-if="!formCadastro.apiToken"
            @click.stop.prevent="gerarApiToken()"
            >Gerar token de api</vs-button
          >
          <vx-input-group v-if="formCadastro.apiToken">
            <vs-input
              id="apiToken"
              v-model="formCadastro.apiToken"
              size="large"
              class="w-full"
              icon-pack="feather"
              icon="icon-lock"
              icon-no-border
              readonly
            ></vs-input>
            <template slot="append">
              <vs-button
                v-tooltip="'Copiar'"
                color="primary"
                type="gradient"
                icon-pack="feather"
                icon="icon-copy"
                class="d-inline mt-2"
                @click.stop.prevent="copiarApiToken()"
              ></vs-button>
            </template>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome"
            id="Nome"
            v-model="formCadastro.nome"
            v-validate="{ required: true, min: 6 }"
            :state="validateState(veeFields, veeErrors, 'Nome')"
            :class="validateStateClass(veeFields, veeErrors, 'Nome')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>CPF</span>
          <vs-input
            size="large"
            class="w-full"
            name="CPF"
            id="CPF"
            v-model="formCadastro.cpf"
            v-validate="{ required: true, min: 14 }"
            :state="validateState(veeFields, veeErrors, 'CPF')"
            :class="validateStateClass(veeFields, veeErrors, 'CPF')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="DOCUMENT_MASK.CPF_ONLY"
            icon-pack="feather"
            icon="icon-user-check"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Email</span>
          <vs-input
            type="email"
            size="large"
            class="w-full"
            name="Email"
            id="Email"
            v-model="formCadastro.email"
            v-validate="{ required: true, email: true }"
            :state="validateState(veeFields, veeErrors, 'Email')"
            :class="validateStateClass(veeFields, veeErrors, 'Email')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-mail"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Celular</span>
          <vs-input
            size="large"
            class="w-full"
            name="Celular"
            id="Celular"
            v-model="formCadastro.celular"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Celular')"
            :class="validateStateClass(veeFields, veeErrors, 'Celular')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="'(##) #####-####'"
            icon-pack="feather"
            icon="icon-smartphone"
            icon-no-border
          />
        </div>
      </div>

      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de SETOR do Menu USUARIO  ==================------->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Setor</span>
          <v-select
            :options="listSetores"
            name="Setor"
            id="Setor"
            :create-option="criaSetor"
            v-model="formCadastro.idSetor"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Setor')"
            :class="validateStateClass(veeFields, veeErrors, 'Setor')"
          ></v-select>
        </div>
      </div>

      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de PERFIL do Menu USUARIO  ==================------->
      <div v-if="$can('Permite editar Perfil', 'Usuário')" class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Perfil</span>
          <v-select
            :options="listPerfis"
            :create-option="criaPerfil"
            name="Perfil"
            id="Perfil"
            :disabled="desabilitarPerfil"
            v-model="formCadastro.idPerfil"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Perfil')"
            :class="validateStateClass(veeFields, veeErrors, 'Perfil')"
          ></v-select>
        </div>
      </div>

      <div
        class="vx-row mb-6"
        v-if="$can('Permitir alterar Corretora', 'Usuário')"
      >
        <div class="vx-col w-full mb-6">
          <span>Empresa</span>
          <v-select
            :options="tipoEmpresas"
            name="Empresa"
            label="label"
            id="Empresa"
            v-model="empresa"
            class="select-large w-full"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Empresa')"
            :class="validateStateClass(veeFields, veeErrors, 'Empresa')"
          ></v-select>
        </div>

        <div v-if="empresa === 'Corretora'" class="vx-col w-full mb-6">
          <span>Nome da Empresa</span>
          <v-select
            :options="listRegionais"
            name="NomeEmpresa"
            label="label"
            id="NomeEmpresa"
            v-model="formCadastro.idRegional"
            class="select-large w-full"
            :reduce="(item) => item.id"
            :state="validateState(veeFields, veeErrors, 'NomeEmpresa')"
            :class="validateStateClass(veeFields, veeErrors, 'NomeEmpresa')"
          ></v-select>
        </div>

        <div v-if="empresa === 'Assessoria'" class="vx-col w-full mb-6">
          <span>Nome da Empresa</span>
          <v-select
            :options="listDivisoes"
            name="NomeEmpresa"
            label="label"
            id="NomeEmpresa"
            v-model="formCadastro.idDivisao"
            class="select-large w-full"
            :reduce="(item) => item.id"
            :state="validateState(veeFields, veeErrors, 'NomeEmpresa')"
            :class="validateStateClass(veeFields, veeErrors, 'NomeEmpresa')"
          ></v-select>
        </div>

        <div v-if="empresa === 'Convênio'" class="vx-col w-full mb-6">
          <span>Nome da Empresa</span>
          <v-select
            :options="listConvenio"
            name="NomeEmpresa"
            label="label"
            id="NomeEmpresa"
            v-model="formCadastro.idConvenio"
            class="select-large w-full"
            :reduce="(item) => item.id"
            :state="validateState(veeFields, veeErrors, 'NomeEmpresa')"
            :class="validateStateClass(veeFields, veeErrors, 'NomeEmpresa')"
          ></v-select>
        </div>
      </div>

      <div v-if="!this.dados.idUsuario" class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Senha de Acesso</span>
          <vs-input
            size="large"
            class="w-full"
            name="Senha"
            id="Senha"
            v-model="formCadastro.senha"
            v-validate="{ required: true, min: 6 }"
            :state="validateState(veeFields, veeErrors, 'Senha')"
            :class="validateStateClass(veeFields, veeErrors, 'Senha')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            type="password"
          />
        </div>
      </div>

      <ErrorsAlert :errors="errors" />

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idUsuario == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <Modal
      class="holamundo"
      title="Informações da Corretora"
      @cancel="clearFormRegional"
      @accept="adicionaRegional"
      :active.sync="activePromptRegionais"
    >
      <div>
        Termine de informar os dados da Corretora para
        <b>continuar</b>.
        <vs-input
          placeholder="Estado"
          v-model="formRegional.estado"
          class="mt-4 mb-2 w-full"
        />
        <vs-input
          placeholder="Cidade"
          v-model="formRegional.cidade"
          class="w-full"
        />
        <vs-button color="success" class="w-full mt-2" @click="adicionaRegional"
          >Cadastar</vs-button
        >
      </div>
    </Modal>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import cpfCnpj from '../../services/cpfCnpj';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import formAddRegional from '../forms/formAddRegional.vue';
import jwt from 'jsonwebtoken';
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import ability from '../../services/ability';
import utilsList from '../../utils/list';
import ErrorsAlert from '../../components/ErrorsAlert';
import Modal from '../../components/Modal.vue';
import profileService from '../../services/profile.api';
import { DOCUMENT_MASK } from '../../constants/cpfCnpj';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
  },
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
  },
  data() {
    return {
      DOCUMENT_MASK,
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      aguardeCadastro: false,
      idEmpresa: null,
      idUsuario: null,
      hasPermission: false,
      listEscritorios: [],
      corretoras: [],
      listPerfis: [],
      listSetores: [],
      listStatusPosVistoria: [],
      languages: lang,
      funcoesValicao: null,
      titleSideBar: 'Adicionar Corretora',
      dadosSideBar: {},
      regionaisUsuario: [],
      modalForm: false,
      listTiposPropostas: [],
      listBancos: [],
      listTiposUsuarios: [],
      listRegionais: [],
      listDivisoes: [],
      listConvenio: [],
      formCadastro: {
        idTipoUsuario: 1,
        idUsuario: null,
        idEmpresa: null,
        apiToken: null,
        status: true,
        nome: '',
        cpf: '',
        cnpj: '',
        susep: '',
        iss: null,
        email: '',
        celular: '',
        telefone: '',
        dataNascimento: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        pais: 'Brasil',
        idSetor: '',
        idPerfil: '',
        idRegional: null,
        banco: null,
        agencia: null,
        conta: null,
        digito: null,
        senha: '',
        idRegionais: [],
        idDivisao: null,
        idConvenio: null,
        idProgramaAfiliado: null,
        idUsuarioUpline: null,
      },
      activePromptRegionais: false,
      formRegional: {
        idEmpresa: '',
        estado: '',
        cidade: '',
        nome: '',
      },
      tipoEmpresas: ['Assessoria', 'BP Seguradora', 'Corretora', 'Convênio'],
      empresa: null,
      decoded: {},
      desabilitarPerfil: false,
      userHierarchy: null,
    };
  },
  methods: {
    async preencheForm() {
      this.listEscritorios = this.dados.dominios.escritorios;

      if (this.dados.idUsuario) {
        this.formCadastro.idUsuario = this.dados.idUsuario;
        this.formCadastro.idDivisao = this.dados.idDivisao;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.apiToken = this.dados.apiToken;
        this.formCadastro.nome = this.dados.nome;
        this.formCadastro.podeFazerVistoria = this.dados.podeFazerVistoria;
        this.formCadastro.email = this.dados.email;
        this.formCadastro.celular = this.dados.celular;
        this.formCadastro.cpf = this.dados.cpf;

        this.formCadastro.idSetor = {
          id: this.dados.idSetor,
          label: this.dados.Setor,
        };

        this.formCadastro.idPerfil = {
          id: this.dados.idPerfil,
          label: this.dados.Perfil,
        };

        this.desabilitarPerfil = false;
        const perfilPermitido = this.listPerfis.find(
          (perfil) => perfil.id === this.dados.idPerfil,
        );

        if (!perfilPermitido && this.userHierarchy > 1) {
          this.desabilitarPerfil = true;
        }

        this.formCadastro.senha = this.dados.senha;

        if (this.dados.idRegional) {
          this.formCadastro.idRegional = this.dados.idRegional;
          this.empresa = 'Corretora';
          if (!this.listRegionais.some((r) => r.id === this.dados.idRegional)) {
            this.listRegionais.push({
              id: this.dados.idRegional,
              label: this.dados.nomeEmpresa,
            });
          }
        }
        if (this.dados.idDivisao) {
          this.formCadastro.idDivisao = this.dados.idDivisao;
          this.empresa = 'Assessoria';
          if (!this.listDivisoes.some((r) => r.id === this.dados.idDivisao)) {
            this.listDivisoes.push({
              id: this.dados.idDivisao,
              label: this.dados.nomeEmpresa,
            });
          }
        }
        if (this.dados.idConvenio) {
          this.formCadastro.idConvenio = this.dados.idConvenio;
          this.empresa = 'Convênio';
          if (!this.listConvenio.some((r) => r.id === this.dados.idConvenio)) {
            this.listConvenio.push({
              id: this.dados.idConvenio,
              label: this.dados.nomeEmpresa,
            });
          }
        }
      } else {
        this.resetForm();
        this.verificaPermissao();
      }
    },

    criaPerfil(event) {
      //this.$vs.loading();
      var formAdd = {
        idEmpresa: this.idEmpresa,
        nomePerfil: event.label,
      };
      service
        .post('g', 'perfis/create/idPerfil', formAdd)
        .then((res) => {
          var adicionado = {
            id: res.data.idPerfil,
            label: event.label,
          };
          this.perfis.push(adicionado);
          this.formCadastro.idPerfil = adicionado;
          notify.notifySuccess(this.$vs, 'Perfil adicionado com sucesso');
        })
        .catch(() =>
          notify.notifyFail(this.$vs, 'Perfil não pode ser adicionado'),
        )
        .finally(() => this.$vs.loading.close());
    },
    criaSetor(event) {
      this.$vs.loading();
      var formAdd = {
        idEmpresa: this.idEmpresa,
        nomeSetor: event.label,
      };
      service
        .post('g', 'setor/create/idSetor', formAdd)
        .then((res) => {
          var adicionado = {
            id: res.data.idSetor,
            label: event.label,
          };
          this.setores.push(adicionado);
          this.formCadastro.idSetor = adicionado;
          notify.notifySuccess(this.$vs, 'Setor adicionado com sucesso');
        })
        .catch(() =>
          notify.notifyFail(this.$vs, 'Setor não pode ser adicionado'),
        )
        .finally(() => this.$vs.loading.close());
    },
    criaRegional(event) {
      this.formRegional.idEmpresa = this.idEmpresa;
      this.formRegional.nome = event;
      this.activePromptRegionais = true;
    },
    clearFormRegional() {
      this.activePromptRegionais = false;
      this.formRegional = {
        idEmpresa: '',
        estado: '',
        cidade: '',
        nome: '',
      };
    },
    adicionaRegional() {
      if (this.formRegional.estado == '' || this.formRegional.cidade == '') {
        notify.notifyFail(this.$vs, 'Setor não pode ser adicionado');
      } else {
        this.$vs.loading();
        service
          .post('g', 'regionais/create/idRegional', this.formRegional)
          .then((res) => {
            var adicionado = {
              id: res.data.idRegional,
              label: this.formRegional.nome,
            };
            this.escritorios.push(adicionado);
            this.formCadastro.idRegional = adicionado;
            notify.notifySuccess(this.$vs, 'Corretora adicionado com sucesso');
            this.clearFormRegional();
          })
          .catch(() =>
            notify.notifyFail(this.$vs, 'Corretora não pode ser adicionada'),
          )
          .finally(() => this.$vs.loading.close());
      }
    },
    openModalInsertEdit(dados) {
      const { idRegional } = dados;

      !idRegional
        ? (this.titleSideBar = `Adicionar Corretora`)
        : (this.titleSideBar = `Editar Corretoras do Usuario`);

      this.modalForm = true;
    },
    closeModais(data) {
      this.formCadastro.idRegionais = data;
      this.regionaisUsuario = data;
      this.modalForm = false;
    },
    concluido() {
      this.buscaDados();
    },
    buscaDados() {
      this.selected = [];
      this.$vs.loading();
      service
        .getAll(this.controllerGeral, {}, 'list/idEmpresa=' + this.idEmpresa)
        .then((res) => {
          this.itens = [];
          this.itensFiltred = [];
          res.data.forEach((element) => {
            let arrAux = [];
            let arrAux2 = [];

            element.Produtos_Grupos.forEach((el) => {
              let obj = {
                idGrupo: el.idGrupo,
                idProduto: el.idProduto,
                idProdutoGrupo: el.idProdutoGrupo,
                nomeGrupo: el.Produtos_grupos.nomeGrupo,
                valor: el.valor,
              };
              arrAux.push(obj);
            });

            element.Produtos_TipoPagamento.forEach((el) => {
              let obj = {
                idTipoPagamento: el.TipoPagamento_Empresa.idTipoPagamento,
                nomePagamento:
                  el.TipoPagamento_Empresa.TipoPagamento_domTipoPagamento
                    .nomePagamento,
                idTipoPagamentoEmpresa: el.idTipoPagamentoEmpresa,
                idProdutoTipoPagamento: el.idProdutoTipoPagamento,
              };
              arrAux2.push(obj);
            });

            element.Grupos = arrAux;
            element.TipoPagamento = arrAux2;

            delete element.Produtos_Grupos;
            delete element.Produtos_TipoPagamento;

            this.itens.push(element);
          });

          this.itensFiltred = [...this.itens];
          this.filtrar(this.ultimoFiltro);
          this.colunas = {};
          if (this.itens[0])
            Object.keys(this.itens[0]).forEach((element) => {
              if (
                element != 'createdAt' &&
                element != 'updatedAt' &&
                element != 'deletedAt' &&
                element.indexOf('id') != 0
              ) {
                this.colunas[element] = element;
              }
            });
        })
        .catch((e) => notify.notifyFail(this.$vs, e))
        .finally(() => this.$vs.loading.close());
    },
    onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;

      var action = 'Atualizar';
      // eslint-disable-next-line no-unused-vars
      let msgRetorno = 'Dados Atualizados com sucesso';
      if (!this.formCadastro.idUsuario) {
        action = 'Adicionar';
        msgRetorno = 'Usuário Adicionado com sucesso';
      }

      if (cpfCnpj.valida_cpf_cnpj(this.formCadastro.cpf) == false) {
        notify.notifyFail(this.$vs, 'Este CPF não é válido');

        return;
      }

      switch (this.empresa) {
        case 'Corretora':
          if (!this.formCadastro.idRegional) {
            notify.notifyFail(
              this.$vs,
              'O campo Nome da Empresa é obrigatório.',
            );
            return;
          }

          this.formCadastro.idDivisao = null;
          this.formCadastro.idConvenio = null;
          break;
        case 'Assessoria':
          if (!this.formCadastro.idDivisao) {
            notify.notifyFail(
              this.$vs,
              'O campo Nome da Empresa é obrigatório.',
            );
            return;
          }

          this.formCadastro.idRegional = null;
          this.formCadastro.idConvenio = null;
          break;
        case 'Convênio':
          if (!this.formCadastro.idConvenio) {
            notify.notifyFail(
              this.$vs,
              'O campo Nome da Empresa é obrigatório.',
            );
            return;
          }

          this.formCadastro.idRegional = null;
          this.formCadastro.idDivisao = null;
          break;
        default:
          this.formCadastro.idRegional = 1;
          this.formCadastro.idDivisao = null;
          this.formCadastro.idConvenio = null;
          break;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          service
            .post('Usuario', action, this.formCadastro)
            .then(() => {
              this.$vs.loading.close();
              notify.notifySuccess(this.$vs, 'Operação Realizada com sucesso');
              this.$emit('concluido');
            })
            .catch((e) => notify.notifyFail(this.$vs, e))
            .finally(() => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
            });
        } else {
          this.$vs.loading.close();
          this.aguardeCadastro = false;
          notify.notifyFail(this.$vs, 'Confira os dados e tente novamente.');
        }
      });
    },

    keymonitor: async function () {
      if (this.formCadastro.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.formCadastro.cep.replace('.', '').replace('-', '');

        try {
          const { data } = await service.post('g', 'BuscaCEP', {
            cep: cepbusca,
          });

          this.formCadastro.endereco = data.street;
          this.formCadastro.bairro = data.neighborhood;
          this.formCadastro.cidade = data.city;
          this.formCadastro.estado = data.state;
        } catch (error) {
          this.formCadastro.endereco = null;
          this.formCadastro.bairro = null;
          this.formCadastro.cidade = null;
          this.formCadastro.estado = null;

          notify.notifyFail(this.$vs, 'Não Foi possível encontrar o cep');
        } finally {
          this.$vs.loading.close();
        }
      }
    },
    resetForm() {
      this.formCadastro = {
        idTipoUsuario: 1,
        status: true,
        nome: '',
        email: '',
        cpf: '',
        celular: '',
        telefone: '',
        dataNascimento: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        pais: 'Brasil',
        idSetor: '',
        idPerfil: '',
        idRegional: '',
        idDivisao: '',
        idConvenio: '',
        senha: '',
        regionais: '',
      };
      this.empresa = '';
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
    defineIdEmpresa() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
        this.idEmpresa = this.decoded.id_empresa;
        this.userHierarchy = this.decoded.perfil.hierarquia;
      }
    },
    buscaDivisao(idRegional) {
      const { divisoes } = this.escritorios.find(
        (regional) => regional.id === idRegional,
      );

      this.divisoes = [];
      this.formCadastro.idDivisao = [];

      divisoes.forEach((element) => {
        this.divisoes.push({
          id: element.idDivisao,
          label: element.nomeDivisao,
        });
        this.formCadastro.idDivisao.push(element.idDivisao);
      });
    },
    atualizaCorretora(idEscritorio) {
      const escritorio = this.listEscritorios.find(
        (e) => e.id === idEscritorio,
      );
      if (escritorio.corretora) {
        this.corretoras = [
          {
            id: escritorio.corretora.idDivisao,
            label: escritorio.corretora.nomeDivisao,
          },
        ];
        this.formCadastro.idDivisao = escritorio.corretora.idDivisao;
      } else {
        this.corretoras = [];
        this.formCadastro.idDivisao = null;
      }
    },
    verificaPermissao() {
      var permissoes = ability.getPermission().$;

      var arrayHasPermission = permissoes.filter(
        (x) =>
          x.subject == 'Usuário' && x.action == 'Permitir alterar Corretora',
      );
      if (arrayHasPermission.length > 0) this.hasPermission = true;
      if (this.hasPermission == false) {
      }
    },
    async gerarApiToken() {
      try {
        const body = {
          idEmpresa: this.idEmpresa,
          idUsuario: this.formCadastro.idUsuario,
        };
        this.$vs.loading();
        const res = await service.post('Usuario', 'criar-api-token', body);
        this.formCadastro.apiToken = res.data.apiToken;
      } catch (error) {
        notify.notifyFail(this.$vs, 'Corretora não pode ser adicionada');
      } finally {
        this.$vs.loading.close();
      }
    },
    copiarApiToken() {
      // Seleciona o conteúdo do input
      var input = document.getElementById('apiToken');

      // Seleciona o conteúdo do input
      input.select();

      // Copia o conteúdo para a área de transferência usando a API Clipboard
      navigator.clipboard
        .writeText(input.value)
        .then(() => {
          notify.notifySuccess(
            this.$vs,
            'Token api copiado para a área de transferência.',
          );
        })
        .catch(() => {
          notify.notifyFail(this.$vs, 'Erro ao copiar');
        });
    },
    async getDominios() {
      try {
        const Promises = [
          this.listarPerfis(),
          functions.buscaDadosSelects(
            'setor',
            this.listSetores,
            'nomeSetor',
            'idSetor',
            `idEmpresa/${this.idEmpresa}`,
          ),
          functions.buscaDadosSelects(
            'regionais',
            this.listRegionais,
            'nome',
            'idRegional',
          ),
          functions.buscaDadosSelects(
            'divisoes',
            this.listDivisoes,
            'nomeDivisao',
            'idDivisao',
          ),
          functions.buscaDadosSelects(
            'convenio',
            this.listConvenio,
            'nome',
            'id',
          ),
        ];

        await Promise.all(Promises);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
    async listarPerfis() {
      const perfis = await profileService.listProfilesByHierarchy();
      this.listPerfis = perfis
        ? perfis
            .map((perfil) => ({
              id: perfil.id,
              label: perfil.name,
              hierarquia: perfil.hierarchy,
            }))
            .sort((a, b) => a.label.localeCompare(b.label))
        : [];
    },
  },
  created() {
    this.defineIdEmpresa();
    this.getDominios();
  },
  components: {
    BotaoSubmit,
    'v-select': vSelect,
    formAddRegional,
    ErrorsAlert,
    Modal,
  },
};
</script>
<!------------ END SCRIPT ------------>
